export const formsActions = {
    DISPLAY_VALIDATION_ERRORS: 'FORMS_DISPLAY_VALIDATION_ERRORS'
};
